import React from "react";
import { Bars3CenterLeftIcon } from "@heroicons/react/24/outline";

export default function SidebarToggleButton({ onClick, className = "" }) {
    return (
        <button
            type="button"
            className={`inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-700 shadow-sm transition hover:border-primary/40 hover:text-primary dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 ${className}`}
            onClick={onClick}
        >
            <span className="sr-only">Abrir menú</span>
            <Bars3CenterLeftIcon className="h-5 w-5" aria-hidden="true" />
        </button>
    );
}
